import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import LoadingButton from "@mui/lab/LoadingButton";
import {
  Box,
  Button,
  Card,
  Divider,
  Grid,
  IconButton,
  TextField,
  Typography,
  Stack,
  Tooltip,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";

import Modal from "Components/Modal";
import Api from "Api";

const ICON_SIZE = 22;

export default function DeleteStationModal({
  closeModal,
  isOpen,
  stationPaths,
  setOpen,
  mutation,
  deleteStationForOnePath,
  isList,
}: any) {
  const [pathRange, setPathRange] = useState<"all" | "one" | "">("");

  // Logic functions

  const handleCloseModal = () => {
    setOpen(false);
  };

  const handleOnAccept = () => {
    if ((isList || pathRange === "all") && mutation) {
      mutation.mutate();
    }

    if (pathRange === "one") {
      deleteStationForOnePath.mutate();
    }
  };

  const handlepathRange = (event: React.MouseEvent<HTMLElement>, newRange: "" | "all" | "one") => {
    if (newRange !== null) {
      setPathRange(newRange);
    }
  };

  return (
    <Modal open={isOpen} onClose={closeModal} size="md">
      <Card sx={{ p: 3 }}>
        <Grid container columnSpacing={3}>
          <Grid item xs={12}>
            <Typography variant="h6" fontWeight="800">
              لیست مسیرهایی که این ایستگاه در آن ها استفاده شده
            </Typography>

            <Box sx={{ maxHeight: "200px", overflowY: "scroll", pr: 1, mt: 1, py: 1 }}>
              {stationPaths?.map((p: any) => (
                <Box sx={{ pl: 1, mt: 1, py: 1, border: "1px solid #aaa", borderRadius: 1 }}>{p.name}</Box>
              ))}
            </Box>
            {!isList ? (
              <ToggleButtonGroup value={pathRange} exclusive onChange={handlepathRange} aria-label="heatMap2-mode">
                <ToggleButton
                  value="one"
                  aria-label="source-mode"
                  style={{
                    height: "56px",
                    backgroundColor: pathRange === "one" ? "#4754CA" : "",
                    color: pathRange === "one" ? "#fff" : "",
                  }}
                >
                  فقط ازین مسیر حذف شود
                </ToggleButton>
                <ToggleButton
                  value="all"
                  aria-label="destination-mode"
                  style={{
                    height: "56px",
                    backgroundColor: pathRange === "all" ? "#4754CA" : "",
                    color: pathRange === "all" ? "#fff" : "",
                  }}
                >
                  از همه مسیرها حذف شود
                </ToggleButton>
              </ToggleButtonGroup>
            ) : null}

            <Grid container mt={2} justifyContent="flex-end" spacing={1}>
              <Grid item xs={3}>
                <Button variant="light" fullWidth size="large" sx={{ fontWeight: "700" }} onClick={handleCloseModal}>
                  انصراف
                </Button>
              </Grid>
              <Grid item xs={4}>
                <LoadingButton loading={mutation?.isLoading} variant="contained" fullWidth size="large" onClick={handleOnAccept}>
                  حذف
                </LoadingButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Card>
    </Modal>
  );
}
